export default __webpack_public_path__ + "static/media/swuLogo.a91b5507.png";